import { useRecordContext } from 'react-admin';

import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import { IForm } from '../../utilities/schemas/form';

const FormBreadcrumb = () => {
  const record = useRecordContext<IForm>();

  useRegisterBreadcrumb({
    title: record?.title || record?.id || '',
    path: `/forms/${record?.id}`,
  });

  return null;
};

export default FormBreadcrumb;
